import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as tag from '../../../../../tag'

/** Renders enum values as tags, optionally using a query-provided color. */
@ngCore.Component({
  imports: [tag.Component],
  selector: 'atn-value-enum',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Optional hex color applied to enum tags. */
  public readonly colorSg = ngCore.input<string | null | undefined>(undefined, {
    alias: 'color',
  })

  /** Declared enum type that determines whether the value is multi-select. */
  public readonly enumSg =
    ngCore.input.required<ents.core.common.value.types.Enum>({
      alias: 'enum',
    })

  /** Raw enum value to display. */
  public readonly valueSg = ngCore.input<
    ents.core.common.value.Raw | undefined
  >(undefined, {
    alias: 'value',
  })

  /** Text displayed for a single-select enum. */
  public readonly singleValueSg = ngCore.computed(
    (enumType = this.enumSg(), value = this.valueSg()) =>
      enumType.isMultiselect
        ? undefined
        : ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.Text,
          ),
  )

  /** Text values displayed for a multi-select enum. */
  public readonly multipleValuesSg = ngCore.computed(
    (enumType = this.enumSg(), value = this.valueSg()) =>
      enumType.isMultiselect
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.List,
          )?.map(String)
        : undefined,
  )
}
